import React, { useState, useEffect } from 'react';
import { Input, Select, Space } from 'antd';
import { INTERACTION_TYPES } from 'util/constants';
import styles from '../../../event-timeline.module.css';

const { Option } = Select;

interface InteractionParamsProps {
  params: any;
  setParams: (params: any) => void;
  selectableAssets: any[];
}

const InteractionParams: React.FC<InteractionParamsProps> = ({
  params,
  setParams,
  selectableAssets,
}) => {
  const [objectId, setObjectId] = useState(params.targetId || '');

  function onChangeObjectId(value: string) {
    setObjectId(value);
    setParams({ ...params, targetId: value });
  }

  useEffect(() => {
    setObjectId(params.targetId);
  }, [params]);

  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span className={styles.label}>Target ID:</span>
        {selectableAssets?.length > 0 ? (
          <Select
            value={objectId}
            onChange={onChangeObjectId}
            placeholder='Select object'
            style={{ width: '100%' }}
          >
            {selectableAssets?.map((asset) => (
              <Option
                key={
                  asset.props.asset.id || asset.props.asset.ref.current?.uuid
                }
                value={
                  asset.props.asset.id || asset.props.asset.ref.current?.uuid
                }
              >
                {asset.props.asset.name}
              </Option>
            ))}
          </Select>
        ) : (
          <Input
            value={params.targetId}
            onChange={(e) => setParams({ ...params, targetId: e.target.value })}
            placeholder='Enter target ID'
          />
        )}
        <span className={styles.label}>Interaction Type:</span>
        <Select
          value={params.interactionType}
          onChange={(value) => setParams({ ...params, interactionType: value })}
          style={{ width: '100%' }}
        >
          <Option value={INTERACTION_TYPES.CLICK}>Click</Option>
          <Option value={INTERACTION_TYPES.PROXIMITY}>Proximity</Option>
          <Option value={INTERACTION_TYPES.COLLISION}>Collision</Option>
        </Select>
      </Space>
    </div>
  );
};

export default InteractionParams;
